import { render } from "./MovieDetailView.vue?vue&type=template&id=7b5f98c0&scoped=true"
import script from "./MovieDetailView.vue?vue&type=script&lang=js"
export * from "./MovieDetailView.vue?vue&type=script&lang=js"

import "./MovieDetailView.vue?vue&type=style&index=0&id=7b5f98c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5f98c0"]])

export default __exports__